import { RestClient } from '@affstore-ds/restclient'

import { CountryTypesApiPaths, CountryTypesComponents } from '../../../types'

export const getCountryCode = async (apiDomain: string) => {
  const client = new RestClient(CountryTypesApiPaths.CountriesV3IpController_countries, {}, apiDomain, {
    mode: 'cors',
    referrerPolicy: 'no-referrer',
  })

  return await client.get<CountryTypesComponents['schemas']['CountryResponseV3Ip']>('')
}
